import type { ReactNode } from "react";

import { Checkbox } from "@/components/ui/checkbox";

/** A titled group of settings inside the Export dialog's Options panel. */
export function ExportOptionGroup({
  title,
  hint,
  children,
}: {
  title: string;
  /** Muted help text under the group's controls. */
  hint?: ReactNode;
  children: ReactNode;
}) {
  return (
    <fieldset className="space-y-2.5">
      <legend className="mb-2 text-xs font-semibold uppercase tracking-wider text-muted-foreground">{title}</legend>
      {children}
      {hint ? <p className="text-xs text-muted-foreground">{hint}</p> : null}
    </fieldset>
  );
}

/** An on/off export setting. */
export function ExportOptionCheckbox({
  checked,
  onCheckedChange,
  children,
}: {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  children: ReactNode;
}) {
  return (
    <label className="flex items-center gap-2 text-sm">
      <Checkbox checked={checked} onCheckedChange={(next) => onCheckedChange(next === true)} />
      {children}
    </label>
  );
}

/** A labelled setting with its control aligned to the end, e.g. a compact select or toggle. */
export function ExportOptionRow({ label, children }: { label: string; children: ReactNode }) {
  return (
    <div className="flex items-center justify-between gap-3">
      <span className="text-sm">{label}</span>
      {children}
    </div>
  );
}
